var skeletonStyles = {"skeleton-bg-color-a":"#eee","skeleton-bg-color-b":"#f5f5f5","skeleton-bg-image":"linear-gradient(90deg, #eee, #f5f5f5, #eee)","skeleton-bg-size":"200px 100%","skeleton-bg-initial-position":"-200px 0","skeleton":"skeleton_skeleton_660c34bb","skeletonShimmer":"skeleton_skeletonShimmer_660c34bb"};

export { skeletonStyles as s };
